/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIReportDatasource } from '@/models/api/report-datasource.model'

const resource = {
    main: 'services',
    module: 'report-datasources'
}
export class ReportDatasourcesServices {
    public static getReportDatasources () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getReportDatasourcesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getReportDatasourcesById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createReportDatasources (params: APIReportDatasource) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editReportDatasources (params: APIReportDatasource) {
        return service.put(`${resource.main}/${resource.module}/${params.datasourceId}`, params)
    }

    public static deleteReportDatasources (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
